// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__15TCP","file":"styles_file__zoV0G"};